import { render, staticRenderFns } from "./BlockForm.vue?vue&type=template&id=1ca8fc63&scoped=true"
import script from "./BlockForm.vue?vue&type=script&lang=js"
export * from "./BlockForm.vue?vue&type=script&lang=js"
import style0 from "./BlockForm.vue?vue&type=style&index=0&id=1ca8fc63&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ca8fc63",
  null
  
)

export default component.exports